import Vue from 'vue'
import Router from 'vue-router'
import {GetInsUuid} from "@/api/explore"
import { SET_INS_ID,SET_DOMAIN_MAP } from '@/store/types'

Vue.use(Router)
const getRouter = async (store) => {
  const domainMap = new Map()
  let domain = location.pathname.split('/')[1];
  if(!domain){
    domain = 'home'
  }
  // if(domain == 'microapp'){
  //   console.log("huoqu",store.state.domain)
  //   domain = store.state.domain?store.state.domain:'home'
  // }
  let result = await GetInsUuid(domain);
  if (typeof result === 'string'){
    result = eval("(" +result+ ")")
  }
  let routes = genNoExitRoutes()
  if(result.code == 0){
      if(result.data.length > 0){
        routes = genRoutes(`(${result.data.map(e => {
          domainMap.set(e.domainName,e)
          return e.domainName;
        }).join('|')})`)
        store.commit(SET_DOMAIN_MAP,domainMap)
        let info = domainMap.get(domain)
        if (domain != store.state.domain){
          store.commit(SET_INS_ID,{insId:info?.insUuid,domain})
        }
      }
  }
  const router = new Router({
    mode: 'history', // 去掉url中的#
    base: '/',
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
  })
  router.beforeEach((to, from, next) => {
    let domain = location.pathname.split('/')[1];
    if(!domain){
      domain = store.state.domain
    }
    if(!domain){
      domain = 'home'
    }
    // store.state.domain?store.state.domain:'home'
    // console.log("save",store.state.domain)
    // if(domain == 'microapp'){
    //   domain = store.state.domain?store.state.domain:'home'
    // }
    let info = domainMap.get(domain)
    store.commit(SET_INS_ID,{insId:info?.insUuid,domain})
    next();
  })
  return router;
}
// 公共路由
export const genRoutes = (domain) => {
  const constantRoutes = [
    {
      name:'Index1',
      path: `/`,
      component: (resolve) => require(['@/views/main/index'], resolve),
    },
    {
      name:'Index',
      path: `/${domain}`,
      component: (resolve) => require(['@/views/main/index'], resolve),
    },
    {
      name:'Scholar',
      path: `/${domain}/scholar`,
      component: (resolve) => require(['@/views/main/scholar'], resolve),
    },
    {
      name:'Ins',
      path: `/${domain}/ins`,
      component: (resolve) => require(['@/views/main/Ins'], resolve),
    },
    {
      name: 'Explore',
      path: `/${domain}/explore`,
      component: (resolve) => require(['@/views/main/Explore'], resolve),
    },
    {
      name:'About',
      path: `/${domain}/about`,
      component: (resolve) => require(['@/views/main/AboutPage'], resolve),
    },
    {
      name:'JournalArticleSubmit',
      path: `/${domain}/journalArticleSubmit`,
      component: (resolve) => require(['@/views/main/JournalArticleSubmit'], resolve),
    },
    {
      name:'Apply',
      path: `/${domain}/apply`,
      component: (resolve) => require(['@/views/main/ApplyPage'], resolve),
    },
    {
      name:'Microapp',
      path: `/${domain}/microapp/**`,
      component: (resolve) => require(['@/views/main/QiankunPage'], resolve),
      meta:{
        isNeedLogin:false
      }
    },
    // {
    //   name:'graedu',
    //   path: `/${domain}/graedu`,
    //   component: (resolve) => require(['@/views/main/QiankunPageTest'], resolve),
    //   meta:{
    //     isNeedLogin:false
    //   }
    // }
  ]
  return constantRoutes;
}

export const genNoExitRoutes = () => {
  return [
    {
      name:'Index',
      path: `*`,
      component: (resolve) => require(['@/views/main/AboutPage'], resolve),
    }
  ]
}

export default getRouter;
